<template>
  <div class="grouping-total">
    <div class="grouping">
      <div class="grouping__title">
        <h4 v-if="subscribableGrouping != null">
          {{ subscribableGrouping.name }}
        </h4>
        <h4 v-else>
          {{ trans('core.total') }}
        </h4>
      </div>
      <div
        v-if="hasEcts('total')"
        class="grouping__ects"
      >
        {{ displayEcts(ectsTotal) }} {{ trans('core.ects') }}
      </div>
    </div>
    <div
      v-for="(characteristic, key) in courseCharacteristics"
      :key="subscribableGrouping.id + '-' + key"
      class="characteristic"
    >
      <div class="characteristic__header">
        <h5
          :id="'angle-down-' + subscribableGrouping.id + '-' + key"
          class="grouping__title characteristic__title"
          hidden
          @click="showCourses(key, false)"
        >
          <span class="characteristic__angle fa fa-angle-down" />
          {{ characteristic != null ? characteristic : trans('core.other') }}
        </h5>
        <h5
          :id="'angle-right-' + subscribableGrouping.id + '-' + key"
          class="grouping__title characteristic__title"
          @click="showCourses(key, true)"
        >
          <span class="characteristic__angle fa fa-angle-right" />
          {{ characteristic != null ? characteristic : trans('core.other') }}
        </h5>
        <div
          v-if="hasEcts(characteristic)"
          class="grouping__ects characteristic__ects"
        >
          {{ displayEcts(getEctsOfCharacteristic(characteristic)) }} {{ trans('core.ects') }}
        </div>
      </div>
      <div
        :id="'show-' + subscribableGrouping.id + '-' + key + '-courses'"
        hidden
        class="courses"
      >
        <Course
          v-for="course in getCoursesOfCharacteristic(characteristic)"
          :key="subscribableGrouping.id + '-' + course.id + '-' + getSubscribable(course).id"
          :course="course"
          :ects-shown="hasEcts('total')"
          :subscribable="getSubscribable(course)"
          :my-subscription="getMySubscription(course)"
        >
          <template
            slot="unsubscription"
            slot-scope="props"
          >
            <slot
              name="unsubscription"
              :unsubscription-course-name="props.unsubscriptionCourseName"
              :unsubscription-subscribable-id="props.unsubscriptionSubscribableId"
            />
          </template>
        </Course>
      </div>
    </div>
  </div>
</template>

<script>
import { displayFloatLocalized } from '@/helpers'
import Course from '@/shared/studyplan/Course'

export default {
  name: 'SubscribableGrouping',
  components: { Course },
  props: {
    subscribableGrouping: {
      required: false,
    },
    courses: {
      required: true,
    },
    subscribables: {
      required: false,
    },
    mySubscriptions: {
      required: false,
    },
    allCourses: {
      required: true,
    },
    openAllCourses: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ectsTotal () {
      return this.getEcts(this.courses)
    },
    courseCharacteristics () {
      const characteristics = Object.values(this.allCourses).map(course => course.characteristics)

      return [...new Set(characteristics)].sort(function (a, b) {
        if (a === null) {
          return 1
        } else if (b === null) {
          return -1
        }
        return a > b ? 1 : -1
      })
    },
  },
  watch: {
    openAllCourses (newValue) {
      this.courseCharacteristics.forEach((characteristic, key) => this.showCourses(key, newValue))
    },
  },
  methods: {
    displayEcts (ec) {
      return displayFloatLocalized(ec, Lang.locale)
    },
    getCoursesOfCharacteristic (characteristic) {
      return Object.values(this.courses).filter(course => {
        return course.characteristics === characteristic
      })
    },
    getEcts (courses) {
      return courses.reduce((acc, course) => {
        acc += course.ects == null ? 0.0 : parseFloat(course.ects)
        return acc
      }, 0.0)
    },
    getEctsOfCharacteristic (characteristic) {
      return this.getEcts(this.getCoursesOfCharacteristic(characteristic))
    },
    getSubscribable (course) {
      return Object.values(this.subscribables).find((item) => {
        return item.course === course.id
      })
    },
    getMySubscription (course) {
      const subscribable = this.getSubscribable(course)

      if (subscribable == null || subscribable.mySubscription == null) {
        return null
      }
      return this.mySubscriptions[subscribable.mySubscription]
    },
    hasEcts (characteristic) {
      if (characteristic === 'total') {
        return this.ectsTotal > 0
      }
      return this.getEctsOfCharacteristic(characteristic) > 0
    },
    showCourses (characteristic, open) {
      const courseSelector = document.querySelector('#show-' + this.subscribableGrouping.id + '-' + characteristic + '-courses')
      const angleDownSelector = document.querySelector('#angle-down-' + this.subscribableGrouping.id + '-' + characteristic)
      const angleRightSelector = document.querySelector('#angle-right-' + this.subscribableGrouping.id + '-' + characteristic)

      if (open) {
        courseSelector.hidden = false
        angleDownSelector.hidden = false
        angleRightSelector.hidden = true
      } else {
        courseSelector.hidden = true
        angleDownSelector.hidden = true
        angleRightSelector.hidden = false
      }
    },
  },
}
</script>

<style scoped lang="scss">

    .grouping-total {
        margin-bottom: 10px;
    }

    .grouping {
        width: 100%;
        display: flex;
        margin-bottom: 10px;

        &__title {
            flex: 1 1 auto;
            padding-left: 10px;
            text-overflow: ellipsis;
        }

        &__ects {
            flex: 0 0 80px;
            padding: 10px;
            text-align: center;
            padding-right: 15px;
            font-size: 14px;
        }
    }

    .characteristic {
        &__header {
            display: flex;
            margin-right: 10px;
            margin-left: 10px;
            border-top: 1px solid #eeeeee;
        }

        &__title {
            cursor: pointer;
        }

        &__angle {
            margin-right: 5px;
        }

        &__ects {
            font-size: 12px;
            padding-right: 2px;
            text-align: right;
        }
    }

    .courses {
        padding-left: 5px;
    }

</style>
